import styled, { css } from 'styled-components';

import ActionIcon from '@/components/atom/ActionIcon/ActionIcon';

export const StyledThreadListItem = styled.li<{ $isactive: boolean; $search?: string }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 4px;
  padding: 1.4rem 2rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
  overflow: visible;

  &:hover {
    background-color: var(--gray-lightest);
  }

  ${({ $isactive }) =>
    $isactive &&
    css`
      background-color: var(--color-highlight-decent);

      & > p {
        margin-left: 2rem;
      }
    `}

  ${({ $isactive, $search }) =>
    $isactive &&
    !$search &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 2rem;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
        background-color: var(--brand-primary);
        border-radius: 50%;
        box-shadow: 0 0 5px 3px var(--color-highlight-lighter);
      }
    `}
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const StyledThreadListItemManager = styled.div`
  border-radius: 4px;
  padding: 0;
  transition: background-color 0.3s ease;
`;

export const InputContainer = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  position: relative;
`;

export const StyledInput = styled.input`
  width: 100%;
  margin: 1rem;
`;

type FavoriteIconProps = {
  isFavorite: boolean;
};

export const FavoriteIcon = styled(ActionIcon)<FavoriteIconProps>`
  display: inline-flex;
  color: ${({ isFavorite }) => (isFavorite ? 'var(--color-favorite)' : 'inherit')};
`;

export const highlightStyle = {
  backgroundColor: 'var(--color-highlight-lighter)',
  padding: '0px',
};

export const StyledItemAction = styled.div<{ $search: string | undefined }>`
  display: flex;
  justify-content: flex-end;
  ${({ $search }) =>
    $search &&
    $search.length > 0 &&
    css`
      width: 100%;
      padding: 0.5rem;
    `}
`;
